import {IconButton, Nav, Panel, PanelType, Stack, Text,} from "@fluentui/react";
import React, {FC, useContext, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {AuthContext} from "../contexts/AuthContext";
import {ApplicationGroups, ApplicationListHelper,} from "../helpers/ApplicationListHelper";
import {theme} from "../index";
import {NavigationPanelContext} from "../state/State";
import "../styles/LeftPanel.css";

export const LeftNavigation: FC = ({
                                       history,
                                       changeSelectedNav,
                                       selectedNavKey,
                                   }: any) => {
    const {HideNavPanel, NavPanelVisible, Navigate} = useContext(
        NavigationPanelContext,
    );
    const {UserInfo, IsDeleted} = useContext(AuthContext);
    const [navGroups, setNavGroups] = useState<ApplicationGroups>();
    const {t, i18n} = useTranslation();

    const handleNavigate = (event: any, element: any) => {
        event.preventDefault();
        Navigate(element.url, undefined);
    };

    useEffect(() => {
        setNavGroups(ApplicationListHelper(UserInfo));
    }, [UserInfo, IsDeleted]);

    return (
        <Panel
            id={"paddingless-content-nav-id"}
            isLightDismiss={true}
            isOpen={NavPanelVisible}
            type={PanelType.smallFixedNear}
            overlayProps={{
                styles: {
                    root: {
                        backgroundColor: "rgba(0,0,0,0.4)",
                    },
                },
            }}
            onDismiss={HideNavPanel}
            styles={{content: "paddingless-content-nav"}}
        >
            <Stack horizontal tokens={{padding: "0 10px"}}>
                <div
                    style={{
                        width: "100%",
                        alignItems: "center",
                        alignContent: "center",
                        textAlign: "left",
                    }}
                >
                    <Text
                        variant={"large"}
                        style={{
                            textAlign: "center",
                            margin: "auto",
                            color: theme?.palette?.themePrimary,
                        }}
                        color={theme?.palette?.themePrimary}
                    >
                        {UserInfo?.user?.companySettings?.pantheonCompanyName}
                    </Text>
                </div>
                <IconButton iconProps={{iconName: "Cancel"}} onClick={HideNavPanel}/>
            </Stack>
            <Nav
                groups={
                    navGroups?.groups.map((group) => ({
                        name: t(group.name),
                        links: group.applications.map((app) => ({
                            disabled: IsDeleted,
                            iconProps: app.icon
                                ? {
                                    iconName: app.icon,
                                    color: group.color,
                                    style: {
                                        color: group.color,
                                    },
                                }
                                : undefined,
                            key: app.url,
                            name: t(app.name),
                            url: app.url,
                            links: app.links?.map((subApp) => ({
                                disabled: IsDeleted,
                                isExpanded: true,
                                iconProps: {
                                    iconName: subApp.icon,
                                    color: group.color,
                                    style: {
                                        color: group.color,
                                    },
                                },
                                key: subApp.url,
                                name: t(subApp.name),
                                url: subApp.url,
                            })),
                            isExpanded: true,
                        })),
                    })) ?? []
                }
                onLinkClick={handleNavigate}
                selectedKey={selectedNavKey}
            />
        </Panel>
    );
};
